import React, { useState } from 'react';
import { Drawer, Box, Typography, IconButton, Divider, Button, MenuItem, Select, List, ListItem, ListItemText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useThread } from '../hooks/useThread';
import { useMessageAction } from '../hooks/useMessageAction';
import { downloadBlob } from '../utils/file';
import * as api from '../api/mail.api';

export default function ThreadDrawer({ open, onClose, messageId, onActionComplete }) {
  const { data } = useThread(messageId, !!open);
  const action = useMessageAction();
  const handleAction = async (msg, act) => {
    if (!msg) return;
    const { mailboxId, folder, uid } = msg;
    await action.mutateAsync({ mailboxId, folder, uid, payload: { action: act } });
    if (onActionComplete) onActionComplete();
  };

  const downloadAttachment = async (mailboxId, folder, uid, partId, filename) => {
    try {
      const blob = await api.mailboxAttachment(mailboxId, folder, uid, partId);
      downloadBlob(blob, filename);
    } catch (e) { console.error(e); }
  };

  return (
    <Drawer anchor="right" open={!!open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', md: 700 } } }}>
      <Box sx={{ p: 2, bgcolor: '#fff', borderBottom: '1px solid #E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h6">{data?.subject || '(no subject)'}</Typography>
          <Typography variant="caption" color="text.secondary">{data?.from?.map(f => f.email).join(', ')}</Typography>
        </Box>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </Box>
      <Box sx={{ p: 2, overflow: 'auto', flex: 1 }}>
        <List>
          {(data?.messages || []).map((m, idx) => (
            <ListItem key={idx} sx={{ mb: 2, bgcolor: '#fff', borderRadius: 1 }}>
              <ListItemText primary={<><strong>{m.from?.map(f=>f.name||f.email).join(', ')}</strong> <Typography variant="caption">{m.date}</Typography></>} secondary={<div dangerouslySetInnerHTML={{ __html: m.body?.html || `<pre>${m.body?.text || ''}</pre>` }} />} />
              {Array.isArray(m.attachments) && m.attachments.map(a => (
                <Button key={a.partId} onClick={() => downloadAttachment(m.mailboxId, m.folder, m.uid, a.partId, a.filename)} startIcon={<span>📎</span>}>
                  {a.filename}
                </Button>
              ))}
            </ListItem>
          ))}
        </List>
      </Box>
      <Box sx={{ p: 2, borderTop: '1px solid #E5E7EB', display: 'flex', gap: 1 }}>
        <Button onClick={() => handleAction(data?.messages?.[0], 'mark_read')}>Mark Read</Button>
        <Button onClick={() => handleAction(data?.messages?.[0], 'mark_unread')}>Mark Unread</Button>
        <Button onClick={() => handleAction(data?.messages?.[0], 'delete')}>Delete</Button>
      </Box>
    </Drawer>
  );
}
